import { request } from 'assets/fetchHandler';

class WechatApi {
  /**
   * 微信配置
   * @param params
   * @returns {*}
   */
  getWechatConfig(params) {
    return request({
      url: '/front/api/xcx_sdk_signature',
      params
    });
  }

  /**
   * 获取用户key值
   * @param data
   * @returns {*|Promise|Promise<any>}
   */
  getUserKey(data) {
    return request({
      url: '/front/api/web/login',
      data,
      method: 'POST'
    });
  }
}

export default new WechatApi();
